import { GetterTree } from 'vuex'
import { RootState } from '@/store/types'
import { PronosticoHistoricoState } from './types'

export const getters: GetterTree<PronosticoHistoricoState, RootState> = {
  pronosticoHistorico (state: PronosticoHistoricoState) {
    return state.pronosticoHistorico
  },
  linkDescarga (state: PronosticoHistoricoState) {
    return state.link_descarga
  }
}
